import { FC, ReactNode } from "react";
import { InfoContainer, Wrapper } from "./styles";
import { useRouteMatch } from "react-router-dom";

//const DISTANCE_FROM_TEAM_SHOWCASE_HEADER = 400;

export const TeamBottomInfo: FC<{ title: ReactNode, buttons: ReactNode}> = ({ title, buttons }) => {

    const isTeamRoute = !!useRouteMatch('/teams/:id');

    if (!isTeamRoute || !buttons) {
        return null;
    }

    return (
        <Wrapper className={'bottom-info'}>
            <InfoContainer>
                {title}
                {buttons}
            </InfoContainer>
        </Wrapper>

    )
}import { FC, ReactNode } from "react";
import { InfoContainer, Wrapper } from "./styles";
import { useRouteMatch } from "react-router-dom";

//const DISTANCE_FROM_TEAM_SHOWCASE_HEADER = 400;

export const TeamBottomInfo: FC<{ title: ReactNode, buttons: ReactNode}> = ({ title, buttons }) => {

    const isTeamRoute = !!useRouteMatch('/teams/:id');

    if (!isTeamRoute || !buttons) {
        return null;
    }

    return (
        <Wrapper className={'bottom-info'}>
            <InfoContainer>
                {title}
                {buttons}
            </InfoContainer>
        </Wrapper>

    )
}